import { Typography } from '@mui/material';

import { ChargingModel } from 'modules/billing/types';
import { renderCreditBalance } from 'modules/billing/utils/renderCreditBalance';
import { renderRequestsBalance } from 'modules/billing/utils/renderRequestsBalance';
import { renderUsdBalance } from 'modules/billing/utils/renderUsdBalance';

import { useBalanceStyles } from './useBalanceStyles';

export interface BalanceProps {
  chargingModel: ChargingModel | undefined;
}

export const Balance = ({ chargingModel }: BalanceProps) => {
  const creditBalance = chargingModel?.balance.credits ?? 0;
  const requestsBalance = chargingModel?.balance.requests ?? 0;
  const usdBalance = chargingModel?.balance.usd ?? 0;

  const usdBalanceString = renderUsdBalance({ usdBalance });

  const isFreemium = chargingModel?.type === 'freemium';
  const isPromo = chargingModel?.type === 'promo';

  const detailedRequestsBalance = renderRequestsBalance({
    isApproximate: true,
    isShortened: true,
    prefix: isPromo || isFreemium ? undefined : `${usdBalanceString} / `,
    requestsBalance,
  });

  const { classes } = useBalanceStyles();

  return (
    <div className={classes.root}>
      <Typography component="p" variant="subtitle1">
        {renderCreditBalance({ creditBalance })}
      </Typography>
      <Typography color="textSecondary" component="p" variant="body4">
        {detailedRequestsBalance}
      </Typography>
    </div>
  );
};
